// extracted by mini-css-extract-plugin
module.exports = {"blackNextButton":"styles_blackNextButton__8Te78","ant-btn-primary":"styles_ant-btn-primary__XJaJ8"};